import { createStyles, makeStyles, Theme } from '@material-ui/core';
import commonStyles from 'config/commonStyles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        ...commonStyles,
        headerContainer: {
            display: 'flex',
            alignItems: 'center',
            padding: '0px 16px',
            borderBottom: `1px solid ${theme.palette.grey['300']}`,
        },
        iconButton: {
            color: theme.palette.common.black,
            marginRight: '10px',
        },
        bottomAppBar: {
            position: 'sticky',
            top: 'auto',
            bottom: 4,
            backgroundColor: theme.palette.background.paper,
            boxShadow: `0 0px 8px ${theme.palette.grey[400]}`,
            marginTop: 4,
            padding: 16
        },
        tableHeader: {
            color: theme.palette.grey[500],
        }
    })
);
